import type { ComponentProps } from 'react';

import type { AvatarAi } from '@mint-lib/tw-components/ai';

export const AGENT_NAMES = {
  VOICE: 'voice_agent',
  ASSISTANT: 'ai_assistant',
  MEDIA_PLANNER: 'media_planner',
  PROJECT_MANAGER: 'project_manager',
  MEDIA_STRATEGIST: 'media_strategist',
  SUPERVISOR: 'supervisor',
  DATA_ANALYST: 'data_analyst',
  REPORT_BUILDER: 'report_builder',
  OFFLINE_PLANER: 'offline_planner',
  OPTIMISATION: 'optimisation_agent',
  MEDIA_MAPPING: 'media_mapping_agent',
} as const;

export const AGENT_ALIASES: Record<AgentNameType, string[]> = {
  ai_assistant: [],
  media_planner: ['media_planner'],
  media_strategist: ['media_strategist', 'strategist'],
  project_manager: ['project_manager'],
  supervisor: ['supervisor', 'ai_assistant'],
  data_analyst: ['data_analyst'],
  report_builder: [
    'report_builder',
    'report_builder_agent',
    'powerpoint_agent',
    'word_agent',
  ],
  voice_agent: ['voice_agent'],
  offline_planner: ['offline_planner'],
  optimisation_agent: ['optimisation_agent', 'optimisation_expert'],
  media_mapping_agent: ['media_mapping_agent'],
};

export type AgentNameType =
  | (typeof AGENT_NAMES)[keyof typeof AGENT_NAMES]
  | (string & {});

export type AgentType = {
  agentName: AgentNameType;
  label: string;
  role: ComponentProps<typeof AvatarAi>['role'];
  desc?: string;
  meta?: {
    isVisibleInAgentWidget?: boolean;
  };
};
